import {
  useTotalMobilityUse,
} from '@src/modules/performance/context/reports-api-hooks';
import Chart from 'react-apexcharts';
import { Link, Text } from '@chakra-ui/react';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Total Mobility Use (Region)',
  content: [
    {
      title: 'Total Mobility Use (Region)',
      description:
  <Text fontSize="inherit" mb={2}>
    The number of people registered in the Total Mobility programme plotted against the number of passengers boardings on Total Mobility services for the Region.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, use - total mobility</Link>
  </Text>,
    },
  ],
};

function PublicTransportTotalMobilityUse() {
  const { data, isLoading } = useTotalMobilityUse();

  const years = [...new Set(data?.map((item) => item.Year))];
  const chartData = [
    {
      name: 'Persons Registered',
      type: 'line',
      data: data?.map((item) => ({
        x: item.Year,
        y: item.PersonsRegistered,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Boardings',
      type: 'line',
      data: data?.map((item) => ({
        x: item.Year,
        y: item.Boardings,
      })),
      color: CHART_COLOURS.orangered,
    },
  ];

  return (
    <ReportSection
      title="Total Mobility Use (Region)"
      isLoading={isLoading || !data}
      informationSource={informationSource}
      lockYear={data?.[0]?.LockYear}
    >
      <Chart
        options={
          {
            title: {
              text: 'Total Mobility Use (Region)',
            },
            chart: {
              animations: {
                enabled: false,
              },
            },
            xaxis: {
              categories: years,
              labels: {
                offsetY: 5,
                rotate: -45,
                rotateAlways: true,
              },
            },
            yaxis: [
              {
                seriesName: 'Boardings',
                opposite: true,
                axisTicks: {
                  show: true,
                },
                title: {
                  text: 'Boardings',
                },
                tooltip: {
                  enabled: false,
                },
                labels: {
                  formatter(y) {
                    return y != null
                      ? `${new Intl.NumberFormat('en', {
                        notation: 'compact',
                        compactDisplay: 'short',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                      }).format(y)}`
                      : '';
                  },
                },
              },
              {
                seriesName: 'Persons Registered',
                opposite: false,
                axisTicks: {
                  show: true,
                },
                title: {
                  text: 'Persons Registered',
                },
                tooltip: {
                  enabled: false,
                },
                labels: {
                  formatter(y) {
                    return y != null
                      ? `${new Intl.NumberFormat('en', {
                        notation: 'compact',
                        compactDisplay: 'short',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                      }).format(y)}`
                      : '';
                  },
                },
              },
            ],
            grid: {
              padding: {
                left: 20,
              },
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              shared: false,
              intersect: true,
            },
          }
        }
        series={chartData}
        type="line"
        width="320"
        height="280"
      />
    </ReportSection>
  );
}

export default PublicTransportTotalMobilityUse;
